import { TrackPayload, TrackingVendor } from '../types';

/*
 * Default data passed with every tracking event
 */
export const getDefaultData = () => {
  // Add default tracking data here (example: from redux or apollo cache) //
  return {};
};

/*
 * Get data and tracking vendor for each Event of Track redux action.
 *
 * Add switch cases in this method for additional Events of Track redux action we want to handle.
 */
export const getDataAndTrackerForTrackEvent = (
  trackPayload: TrackPayload,
  reduxState: any
): [any, TrackingVendor] => {
  const trackPayloadData = trackPayload.params ?? {};
  const tracker = trackPayload.vendor || 'all';
  switch (trackPayload.event) {
    case `FILTER_EVENT`: {
      const withFilterData = {
        ...trackPayloadData,
        filters: {
          ...reduxState.filter,
        },
      };
      return [withFilterData, tracker];
    }
    default:
      return [trackPayloadData, tracker];
  }
};

/*
 * Get data and tracking vendor for any Redux action we want to track.
 * It returns null by default to mark the action as not to be tracked.
 *
 * Add switch cases in this method for additional Actions we want to track.
 */
export const getDataAndTrackerForAction = (
  action: any
): [any, TrackingVendor] | null => {
  switch (action.type) {
    case 'TOAST_MESSAGE': {
      // Add additional tracking data for any action types //
      // every toast message gets logged as an example //
      const data =
        action.payload.message.length > 0
          ? {
              message: action.payload.message,
            }
          : {};
      return [data, 'all'];
    }
    default: {
      return null;
    }
  }
};
try {
    // @ts-ignore
    getDataAndTrackerForAction.displayName = "getDataAndTrackerForAction";
    // @ts-ignore
    getDataAndTrackerForAction.__docgenInfo = { "description": "", "displayName": "getDataAndTrackerForAction", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/analyticsManager/tracking/prepareTrackData.ts#getDataAndTrackerForAction"] = { docgenInfo: getDataAndTrackerForAction.__docgenInfo, name: "getDataAndTrackerForAction", path: "src/shared/analyticsManager/tracking/prepareTrackData.ts#getDataAndTrackerForAction" };
}
catch (__react_docgen_typescript_loader_error) { }